import { useEffect, useRef, useState } from 'react';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { accountService } from '../../_services/accounts.service';
import { usersService } from '../../_services/users.service';
import { useSignalR } from './chat.signalr.context';


export function useChatPresence(currentUserId: string) {
    const [users, setUsers] = useState<any>([]);
    const { onlineUsers } = useSignalR();

    const isAdmin = accountService.isAdmin || accountService.isUser;

    const fetchData = async () => {
        return await usersService.getAllUsers()
            .then(
                json => {
                    setUsers(json);
                }, handleErrorResponse)
            .finally(() => { });
    };

    useEffect(() => {
        if (isAdmin)
            fetchData();
    }, []);

    const _onlineUsers = users.map((_user: { id: string; }) => ({
        ..._user,
        online: onlineUsers.includes(_user.id),
    }));

    return { users: _onlineUsers };
}
